import React from "react";

// TaskScape logo: static scene (knight + mage + scroll) with a floating, leaning wordmark
// and an idle red-chinchompa that peeks from behind the letters.
export function Logo({ variant = "header" }) {
  const isHero = variant === "hero";
  const wrapClass = isHero ? "relative inline-block w-full max-w-2xl mx-auto" : "relative inline-block";
  const sceneClass = isHero ? "block w-full h-auto" : "block h-16 sm:h-20 w-auto";
  const alt = "TaskScape — Slayer styled tasks for your OSRS account";

  return (
    <div className={wrapClass} data-testid="app-brand" style={{ filter: "drop-shadow(0 6px 10px rgba(0,0,0,0.45))" }}>
      <img src="/taskscape-scene.png" alt={alt} className={sceneClass} style={{ imageRendering: "auto" }} />
      <div className="absolute inset-0 word-lean pointer-events-none">
        <div className="relative w-full h-full taskscape-float">
          <img
            src="/chinchompa.png"
            alt=""
            aria-hidden="true"
            data-testid="logo-chinchompa"
            className="absolute chin-peek"
            style={{ left: "63%", top: "-10%", width: "16%", zIndex: 1, imageRendering: "auto" }}
          />
          <img
            src="/taskscape-word.png"
            alt=""
            aria-hidden="true"
            className="relative w-full h-full object-contain"
            style={{ zIndex: 2, imageRendering: "auto" }}
          />
        </div>
      </div>
    </div>
  );
}
